import { Stack } from "@mui/material";
import { To } from "react-router";

import { MapPanelScrollableArea } from "~/modules/map/components/MapPanel";

import { EnrichedTimelineItem } from "../../hooks/data-transform-utils/timelineEnrichment";
import { TimelineItemTime } from "./components/TimelineItemTime";
import { TravelTimelineItem } from "./components/TravelTimelineItem";
import { VisitTimelineItem } from "./components/VisitTimelineItem";

export function RouteDetailPanelTimeline({
    timeline,
    visitClickHref,
    areaNameHref,
    onRemovePickupPointClick,
    onRemoveVisitClick,
    ownerFieldworkerId,
    loadingToRemoveShiftId,
    loadingToRemoveVisitId,
}: {
    timeline: EnrichedTimelineItem[];
    visitClickHref: (plannerAreaId: string, plannerVisitId: string) => To;
    areaNameHref: (plannerAreaId: string) => To;
    onRemovePickupPointClick: (shiftId: string) => void;
    onRemoveVisitClick: (visitId: string) => void;
    ownerFieldworkerId?: string;
    loadingToRemoveShiftId: string | null;
    loadingToRemoveVisitId: string | null;
}) {
    const visitCount = timeline.filter(item => item.__typename === "GqlPlannerV2Visit").length;
    const isVisitRemovable = visitCount > 1;
    return (
        <MapPanelScrollableArea
            sx={theme => ({
                background: `linear-gradient(to right, transparent 36px, ${theme.palette.divider} 36px, ${theme.palette.divider} 37px, transparent 37px)`,
            })}
        >
            {timeline.map(timelineItem => (
                <Stack key={timelineItem.key}>
                    <Stack direction="row" columnGap={2} padding={2}>
                        <TimelineItemTime
                            startTime={timelineItem.time}
                            endTime={timelineItem.__typename === "GqlPlannerV2Visit" ? timelineItem.visitEndTime : null}
                        />

                        {timelineItem.__typename === "GqlPlannerV2TravelGroupTravelTimelineItem" && (
                            <TravelTimelineItem
                                pickups={timelineItem.pickups}
                                dropoffs={timelineItem.dropoffs}
                                ownerFieldworkerId={ownerFieldworkerId}
                                onRemovePickupPointClick={onRemovePickupPointClick}
                                loadingToRemoveShiftId={loadingToRemoveShiftId}
                            />
                        )}

                        {timelineItem.__typename === "GqlPlannerV2Visit" && (
                            <VisitTimelineItem
                                visit={timelineItem}
                                visitClickHref={visitClickHref}
                                areaNameHref={areaNameHref}
                                removable={isVisitRemovable}
                                onRemoveClick={onRemoveVisitClick}
                                loadingToRemoveVisitId={loadingToRemoveVisitId}
                            />
                        )}
                    </Stack>
                </Stack>
            ))}
        </MapPanelScrollableArea>
    );
}
